import PropTypes from 'prop-types'
import API from '../../../utils/http/api'

// NOT FILES (They are just strings, Action Types)
const RESET = 'steppingblocks/resetPassword/RESET'
const REQUEST = 'steppingblocks/resetPassword/REQUEST'
const SUCCESS = 'steppingblocks/resetPassword/SUCCESS'
const FAILURE = 'steppingblocks/resetPassword/FAILURE'


// Start reducer
const initialState = {
  error: null,
  requestEnded: false,
  requestStarted: false,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case RESET:
      return initialState
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestEnded: false,
        requestStarted: true,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        requestStarted: true,
      }
    case FAILURE:
      return {
        ..._state,
        error: payload.error,
        requestEnded: true,
        requestStarted: true,
      }
    default:
      return _state
  }
}


// Start Actions
export const clearResetPassword = () => ({
  type: RESET,
})

export const performResetPassword = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.post('/users/finish_password_reset', params)
    dispatch({ type: SUCCESS, payload: data })
    return data
  } catch (error) {
    dispatch({ type: FAILURE, payload: { error: error.message } })
    throw new Error(error)
  }
}


// Start PropTypes
export const resetPasswordPropTypes = PropTypes.shape({
  error: PropTypes.string,
  requestEnded: PropTypes.bool.isRequired,
  requestStarted: PropTypes.bool.isRequired,
})


// @TODO Start Test Data
export const resetPasswordTestData = {
  error: null,
  requestEnded: false,
  requestStarted: false,
}



// WEBPACK FOOTER //
// ./src/routes/unauthenticated/ResetPassword/resetPasswordDuck.js